import { useDispatch } from 'react-redux'
import { setLocalBasePath } from '@utils/navigationUtil'
import { setAppVisibleAllowed, setReadonlyMode } from '@redux/slices/workflowSlice'
import { useAppNavigate } from '@hooks/useAppNavigate'
import { ROUTES } from '@constants/index'
import { OpenDrawerEventPayload } from '@typesApp/AppEvent'
import { usePathBuilder } from './usePathBuilder'

type UseOpenDrawerReturn = {
  openDrawer: (payload?: OpenDrawerEventPayload) => void
}

export const useOpenDrawer = (): UseOpenDrawerReturn => {
  const dispatch = useDispatch()
  const buildPath = usePathBuilder()
  const navigate = useAppNavigate()

  const doProceed = (payload?: OpenDrawerEventPayload) => {
    dispatch(setAppVisibleAllowed())
    if (payload?.viewOnly) {
      dispatch(setReadonlyMode())
    }

    // TODO: read from config to get the default route
    navigate(
      buildPath(payload?.target ?? ROUTES.INSURANCE_MEMBER),
      payload?.navigateState ? { state: payload?.navigateState } : undefined
    )

    if (typeof payload?.callback === 'function') {
      payload?.callback?.()
    }
  }

  const openDrawer = (payload?: OpenDrawerEventPayload) => {
    setLocalBasePath()
    doProceed(payload)
  }

  return {
    openDrawer,
  }
}
